import React, { Component } from "react";
import {
    Button,
    Navbar,
    NavbarGroup,
    NavbarHeading,
} from "@blueprintjs/core";
import { Link } from "react-router-dom";

import { getSession, getRole } from "../utils/helpers";
import { ThemeContext } from "../components/ThemeContext";
import { SUBMENU } from "../utils/constants";          // ⬅️  tab-uri default

import "../css/menu.scss";
import { withRouterParams } from "../utils/withRouterParams"; // ⬅️ injectează navigate

class MainMenu extends Component {
    static contextType = ThemeContext;

    componentDidMount() {
        // console.log(this.props)
        // window.addEventListener("session-updated", this.handleSessionChange);
    }
    componentWillUnmount() {
        // window.removeEventListener("session-updated", this.handleSessionChange);
    }
    handleSessionChange = () => this.setState({ session: getSession() });
    /* ─────  calculează “home URL” în funcţie de rol  ───── */
    getHomeUrl = () => {
        const session = getSession() || {};
        const role = getRole(session);
        const orgSlug = session?.organization?.organization_slug;
        const teamSlug = session?.team?.slug;

        switch (role) {
            case "superadmin":
                return "/superadmin";
            case "admin": {
                const firstTab = SUBMENU.admin[0].slug;      // "echipe"
                return `/admin?org=${orgSlug}&tab=${firstTab}`;
            }
            case "coach": {
                const firstTab = SUBMENU.echipa[0].slug;     // "calendar"
                return `/echipa?org=${orgSlug}&echipa=${teamSlug}&tab=${firstTab}`;
            }
            case "viewer":
                return `/${orgSlug}/${teamSlug}/dashboard/players`;
            default:
                return "/";
        }
    };

    render() {
        const session = getSession();
        const role = getRole(session);
        const orgSlug = session?.organization?.organization_slug || "";
        const orgName = session?.organization?.organization_name || "";
        const { theme, toggleTheme } = this.context;
        const teamName = session?.team?.name;
        // console.log('##########', session)

        /* Gear icon → admin home (dacă e admin / superadmin) */
        const adminDefaultTab = SUBMENU.admin[0].slug;   // "echipe"
        const adminUrl = `/admin?org=${orgSlug}&tab=${adminDefaultTab}`;
        let pathname = this.props?.location?.pathname;
        const makeHeaderLink = (label) => (
            <Link to={this.getHomeUrl()} className="navbar-heading-link">
                <div className="font-header">{label}</div>
            </Link>
        );

        let navbarInfo = "";
        if (["/admin"].includes(pathname)) {
            navbarInfo = makeHeaderLink(orgName);
        } else if (["/echipa"].includes(pathname)) {
            navbarInfo = makeHeaderLink(
                orgName === teamName ? orgName : `${orgName} - ${teamName}`
            );
        }

        return (
            <Navbar className="main-menu">
                <NavbarGroup className="menu-left">
                    <NavbarHeading className="navbar-heading">
                        <Link to={this.getHomeUrl()}>
                            <img
                                className="logo"
                                src="/logo2.png"
                                alt="Fotbal Manager"
                                style={{ cursor: "pointer" }}
                            />
                        </Link>
                        {navbarInfo}
                        {/* {
                            session?.organization?.organization_name &&
                            <div className="font-header">{session?.organization?.organization_name} {}</div>
                        } */}
                    </NavbarHeading>
                </NavbarGroup>


                <NavbarGroup className="menu-right">
                    {(role === "admin" || role === "superadmin") && (
                        <Link to={adminUrl}>
                            <Button minimal icon="cog" className="menu-link" />
                        </Link>
                    )}

                    {/* <Button
                        minimal
                        onClick={toggleTheme}
                        icon={theme === "dark" ? "flash" : "moon"}
                    /> */}

                    <Button
                        minimal
                        icon="log-out"
                        onClick={() => {
                            localStorage.removeItem("session");
                            window.location.href = "/login";
                        }}
                    />
                </NavbarGroup>
            </Navbar>
        );
    }
}

export default withRouterParams(MainMenu);
